// https://ant.design/components/icon/

import { createFromIconfontCN } from '@ant-design/icons'

const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2576270_6l6oj2gi86s.js',
})

export default IconFont
